import { Flex } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useUser } from 'src/context/userContext'
import { SafariDescriptionSection } from './components/DescriptionLandingPage'
import { EdgecasesFooter } from './components/FooterLandingPage'
import { EdgecasesKnowMore } from './components/KnowMore'

const SafariLandingPage: React.FC = () => {
  const { user } = useUser()

  useEffect(() => {
    if (!user) return
  }, [user])

  return (
    <Flex flexDirection='column' bg='white' justifyContent='center' alignItems='center' w='100%'>
      <Helmet>
        <title> Instalar o Chrome | Education Journey</title>
      </Helmet>
      <SafariDescriptionSection />
      <EdgecasesKnowMore />

      <EdgecasesFooter />
    </Flex>
  )
}

export default SafariLandingPage
